'use client';

import { useEffect } from 'react';

export const useImpressionPixel = ({
  enabled,
  pixelUrl,
}: {
  enabled?: boolean;
  pixelUrl?: string;
}) => {
  useEffect(() => {
    if (enabled && pixelUrl) {
      const img = new Image();
      img.src = pixelUrl;
      img.style.display = 'none';
      document.body.appendChild(img);

      return () => {
        if (document.body.contains(img)) {
          document.body.removeChild(img);
        }
      };
    }
  }, [enabled, pixelUrl]);
};
